import SmallBadge, { badgeTypes as badges } from './SmallBadge';

export const badgeTypes = badges;
export default SmallBadge;
